import {useState} from 'react'

const useButtonLoading = (onClick?: (e: React.MouseEvent) => any) => {
    const [loading, setLoading] = useState<boolean>(false)
    const onClickHandler: React.MouseEventHandler = (e: React.MouseEvent) => {
        if (onClick) {
            const promise = onClick(e)
            if (promise instanceof Promise) {
                setLoading(true)
                promise.finally(() => setLoading(false))
            }
        }
    }
    return {onClick: onClickHandler, loading}
}
export default useButtonLoading
